import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { ImageIntellResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useGetSingleImageIntell = (
  id: number | string,
  refetchInterval?: number
) => {
  return useQuery<any, AxiosError<any>, ImageIntellResponse>(
    ["singleImageIntellExecution", id],
    async () => {
      const data = await axiosClient.get<ImageIntellResponse>(
        `/image-intell/info/${id}`
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      // keepPreviousData: true,
      enabled: false,
    }
  );
};
